// export default Sidebar;
import React from "react";
import { NavLink } from "react-router-dom";
import { USER_ROLES } from "../../interfaces/roles";
import "../../assets/scss/pages/admin/_sidebarAdmin.scss";

interface TabItem {
	name: string;
	route: string;
	icon?: React.ElementType;
	tabRoles?: USER_ROLES[];
}

interface SidebarProps {
	tabs: TabItem[];
	userRole: USER_ROLES;
}

const Sidebar: React.FC<SidebarProps> = ({ tabs, userRole }) => {
	return (
		<div className="sidebar-container">
			{/* Header */}
			<div className="sidebar-header">Admin</div>

			{/* Sidebar Links */}
			<div className="sidebar-content">
				<div className="sidebar-nav">
					{tabs
						.filter((tab) => !tab.tabRoles || tab.tabRoles.includes(userRole))
						.map((tab) => {
							const Icon = tab.icon;
							return (
								<NavLink
									key={tab.name}
									to={tab.route}
									exact
									className="sidebar-link"
									activeClassName="sidebar-link-active"
								>
									{Icon && <Icon className="sidebar-icon" />}
									<span className="sidebar-text">{tab.name}</span>
								</NavLink>
							);
						})}
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
